module.exports = __webpack_public_path__ + "media/images/icon_camera_blue-4b61c004213ea8ce1a7644d9c9d2d7af.png";